import { sentry } from '@frontend/tracking';
import { useGetBusinessDetailsQuery } from '../queries';

const SUPPORTED_BOOKING_SOFTWARE = ['NEXHEALTH', 'WEAVE'];

export const useSupportedBookingSoftware = ({
  locationId,
  orgId,
  isEnabled = false,
}: {
  locationId: string;
  orgId: string;
  isEnabled?: boolean;
}) => {
  const { data: businessDetailsData } = useGetBusinessDetailsQuery({
    request: { locationId, orgId },
    options: {
      enabled: isEnabled && !!locationId && !!orgId,
      onError: (error) =>
        sentry.error({
          error,
          team: 'schedule',
          topic: 'scheduling',
          addContext: {
            name: 'GetBusinessDetails error in useSupportedBookingSoftware',
            context: { locationId, orgId, error },
          },
        }),
    },
  });

  const bookingSoftware = businessDetailsData?.businessDetails?.bookingSoftware;

  const hasSupportedBookingSoftware =
    !!bookingSoftware && SUPPORTED_BOOKING_SOFTWARE.some((s) => s === bookingSoftware);

  return {
    hasSupportedBookingSoftware,
  };
};
